import React from 'react'
import './footer.css'
import { Link } from 'react-router-dom'
function Footer() {
    return (
        <div>
            <footer class="footer">
                <div class="container">
                    <div class="row">
                        <div class="footer-col">
                            <h4><Link to="/who-we-are">About Us</Link></h4>
                            <h4><Link to="/terms-and-conditions">Terms and Conditions</Link></h4>
                        </div>
                        <div class="footer-col">
                            <h4><a href="/who-we-are#Vision&Mission">Vision and Mission</a></h4>
                            <h4><Link to="/privacy-policy">Privacy Policy</Link></h4>
                        </div>
                        <div class="footer-col">
                            <h4><a href="/who-we-are#OurTeam">Our Team</a></h4>
                            <h4><Link to="/Schedule-of-charges">Schedule Of Charges</Link></h4>
                        </div>
                        <div class="footer-col">
                            <h4><Link to="/contact-us">Contact us</Link></h4>
                            <h4><Link to="/gallery">Gallery</Link></h4>
                        </div>
                         <div class="footer-col">
                            <h4><Link to="/grievance-redressal-mechanism">Grievance Redressal</Link></h4>
                        </div>
                          <div class="footer-col">
                   <h4><a href="https://forms.gle/bP5xBfJwztWzEsB26" target="_blank" rel="noopener noreferrer"> Nach Cancellation Link</a> </h4>                       </div>
                    </div>
                </div>
                <div class="footer-rights">
                    <p>2025@Kaabil Finance, All Rights Reserved</p>
                </div>
            </footer>
        </div>
    )
}
export default Footer